import { useEffect } from 'react';

const TypeHidden = ({ field, updateValidationOnChange }) => {
  useEffect(() => {
    updateValidationOnChange([field.key], field.value);
  }, []);

  return <></>;
};

export default TypeHidden;
